import {
  DETAILS_LOADED,
  SIZE_SELECTED,
  ADD_TO_COLLECTION,
  UPDATE_IN_WISHLIST_PRODUCTS,
  PRODUCT_NOT_FOUND,
  FETCH_USER_ENCODED_ID,
} from './productDetailsConstants';
import {
  findColorSwatches,
  getActualSwatch,
  buildMediaURL,
  getSizeData,
  isNotifyMeAllowed,
  isMultiVariantProduct,
} from './productDetailsUtils';

const { productType } = window.inlineProductDetails;

const detailsPage = (
  state = {
    loadedProducts: [],
    loadedProduct: {},
    sizeSelectedItem: null,
    hasStock: true,
    colorSwatches: [],
    actualColorSwatch: {},
    sizes: [],
    selectedSize: null,
    productNotFoundContent: '',
    disableNotifyMe: false,
    userEncodedId: null,
  },
  action
) => {
  switch (action.type) {
    case ADD_TO_COLLECTION: {
      return {
        ...state,
        loadedProducts: [...state.loadedProducts, action.product],
      };
    }
    case DETAILS_LOADED: {
      const colorSwatches = findColorSwatches(action.data.classificationGroups);
      const sizeData = getSizeData(action.data);
      const selectedSize = isMultiVariantProduct(productType)
        ? {}
        : { selectedSize: sizeData[0], sizeSelectedItem: sizeData[0] };
      const disableNotifyMe = !isNotifyMeAllowed(action.data);

      return {
        ...state,
        loadedProduct: action.data,
        hasStock: action.data.hasStock,
        colorSwatches: buildMediaURL(colorSwatches),
        actualColorSwatch: getActualSwatch(colorSwatches, action.data.productCode),
        disableNotifyMe,
        sizes: sizeData,
        ...selectedSize,
        productType,
      };
    }
    case SIZE_SELECTED:
      return {
        ...state,
        sizeSelectedItem: action.data,
        selectedSize: action.data,
      };
    case UPDATE_IN_WISHLIST_PRODUCTS:
      return {
        ...state,
        loadedProducts: action.loadedProducts,
        loadedProduct: action.loadedProduct,
      };
    case PRODUCT_NOT_FOUND:
      return {
        ...state,
        productNotFoundContent: action.payload.notFoundContent,
        loadedProduct: action.payload.loadedProduct,
      };
    case FETCH_USER_ENCODED_ID:
      return {
        ...state,
        userEncodedId: action.data,
      };
    default:
      return state;
  }
};

export default detailsPage;
